export const API = {
    URL_HYBRIS_SYSTEM_INFO: `/rest/v2/{siteName}/system-info`,
    URL_NEXT_JS_INFO: '/api/info',
};

export const QUERY_KEYS = {
    HYBRIS_INFO: 'hybris-info',
    NEXT_JS_INFO: 'next-js-info',
};
